import type { ReactNode } from 'react'
import { Avatar, PageHeader } from '../base/ui.tsx'

/** A page's title (level 1) or a part's (level 2), with an optional line under it. */
export function Heading({ text, meta, level = 1 }: { text: ReactNode; meta?: ReactNode; level?: 1 | 2 }) {
  if (level === 1) return <PageHeader title={text} meta={meta} />
  return (
    <div className="ui-heading-2">
      <h2>{text}</h2>
      {meta && <p>{meta}</p>}
    </div>
  )
}

/** A paragraph: `muted` for secondary notes, `danger` for problems; `meta` size for captions; `mono` for ids and numbers. */
export function Text({
  children,
  tone = 'default',
  size = 'body',
  mono = false,
}: {
  children: ReactNode
  tone?: 'default' | 'muted' | 'danger'
  size?: 'body' | 'meta'
  mono?: boolean
}) {
  return (
    <p className="ui-text" data-tone={tone} data-size={size} data-mono={mono || undefined}>
      {children}
    </p>
  )
}

/** An avatar with the player's name beside it. */
export function NamedAvatar({ name, src, size = 28 }: { name: string; src?: string | null; size?: number }) {
  return (
    <span className="ui-named-avatar">
      <Avatar name={name} src={src} size={size} />
      <span>{name}</span>
    </span>
  )
}
